import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-menu',
  templateUrl: './no-menu.component.html',
  styleUrls: ['./no-menu.component.css']
})
export class NoMenuComponent implements OnInit {

  constructor() {
    document.body.style.backgroundColor = "#3f546f"
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/no-menu/no-menu.component.ts